import { $api } from "./api-client";

export type FeatureFlags = {
  avatars3d: boolean;
  avatarsLiveavatar: boolean;
  voiceAuth: boolean;
};

const DEFAULTS: FeatureFlags = {
  avatars3d: false,
  avatarsLiveavatar: false,
  voiceAuth: false,
};

export function useFeatureFlags(): FeatureFlags {
  const { data } = $api.useQuery(
    "get",
    "/api/config/feature-flags",
    {},
    { staleTime: Infinity },
  );
  return data ?? DEFAULTS;
}

export function useFeatureFlagsLoading(): boolean {
  const { isLoading } = $api.useQuery(
    "get",
    "/api/config/feature-flags",
    {},
    { staleTime: Infinity },
  );
  return isLoading;
}
